import React from "react";

import { useSelector } from "react-redux";

import { ReadOnly } from "components/ReadOnly";
import { TabLabel } from "components/TabSelector";
import { DefaultTab } from "components/TabSelector/TabRow";

import theme from "constants/theme";

import { getIsRolePermissionsEnabled } from "selectors";

import { useHasTemporaryBusinessesPermission } from "hooks";

export const SecurityTrimmedNavigationTab = props => {
  const { attentionColorSelector, hasPermissionSelector, title, ...tabProps } =
    props;
  const hasPermission = useSelector(state =>
    // Not all Roles user permissions yet. Only perform permission tests for Roles with the permissions machinery enabled on them
    getIsRolePermissionsEnabled(state) ? hasPermissionSelector(state) : true,
  );
  const hasTemporaryBusinesses = useHasTemporaryBusinessesPermission();
  const attentionColor = useSelector(state =>
    typeof attentionColorSelector === "function"
      ? attentionColorSelector(state, hasTemporaryBusinesses)
      : null,
  );
  if (!hasPermission) {
    return null;
  }

  const tabText = (
    <>
      <ReadOnly readOnly={!hasPermission} showLock /> {title}
    </>
  );

  const attentionProps = attentionColorSelector
    ? {
        TabLabelComponent: TabLabel,
        tabLabelComponentProps: {
          color: attentionColor ? theme.colors[attentionColor] : null,
        },
      }
    : {};

  return (
    <DefaultTab
      {...tabProps}
      {...attentionProps}
      disabled={!hasPermission}
      title={tabText}
    />
  );
};
